import { NgClass } from '@angular/common';
import { Component, effect, input, model, signal, viewChild, WritableSignal } from '@angular/core';
import { ImageFile, ImageUploaderDirective } from './image-uploader/image-uploader.directive';

@Component({
  selector: 'dropbox',
  imports: [NgClass, ImageUploaderDirective],
  templateUrl: './dropbox.component.html',
  styleUrl: './dropbox.component.scss',
})
export class DropboxComponent {

  imageUploaderDirective = viewChild<ImageUploaderDirective>(' image-dropbox');
  accepts = input.required<string>();

  files = model<ImageFile[] | null>()
  multiple = input<boolean>(true);
  withPreview = input<boolean>(false);
  maxFileSize = input<number>(5);

  filesDragging: WritableSignal<boolean> = signal(false);
  imgPreview: any;

  constructor() {
    effect(() => {
      const currentFiles = this.files();
      if (currentFiles && currentFiles.length > 0) {
        this.imgPreview = currentFiles[0].url;
      } else {
        this.imgPreview = null;
      }
    });
  }

  onDropFiles(files: ImageFile[]): void {
    this.files.set([...(this.files() ?? []), ...files]);
    if (files.length === 1) {
      this.imgPreview = files[0].url;
    }
  }

  click() {
    this.imageUploaderDirective()?.onClick();
  }

  clearPreview() {
    this.imgPreview = null;
    this.files.set(null);
  }
}
